// extracted by mini-css-extract-plugin
export var avatarContainer = "_82-0";
export var avatarTypingWave = "_82-i";
export var gray = "_82-f";
export var green = "_82-c";
export var icon = "_82-9";
export var image = "_82-1";
export var lg = "_82-6";
export var md = "_82-5";
export var presenceDot = "_82-b";
export var red = "_82-d";
export var sm = "_82-4";
export var status = "_82-a";
export var typingDot = "_82-h";
export var typingPill = "_82-g";
export var xl = "_82-7";
export var xs = "_82-3";
export var xxl = "_82-8";
export var xxs = "_82-2";
export var yellow = "_82-e";